import noodleApiClient, { ApiDefinition } from '@noodleApi';

type Input = ApiDefinition['/creators/{creatorId}/creditors/{creditorId}']['PUT']['params'] & ApiDefinition['/creators/{creatorId}/creditors/{creditorId}']['PUT']['body'];
type Output = ApiDefinition['/creators/{creatorId}/creditors/{creditorId}']['PUT']['response'];

const updateCreatorCreditor = async ({ creatorId, creditorId, ...body }: Input): Promise <Output> => {
  const data = await noodleApiClient.put(`/creators/${creatorId}/creditors/${creditorId}`, body);
  return data.data;
};

export default updateCreatorCreditor;